import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchInspector(serviceProviderId, inspectorId) {
    return RequesterV1.get(
      `service_provider/tech_visits/producer_inspectors/${serviceProviderId}/fetch_inspector/${inspectorId}`
    );
  },

  fetchProducers(serviceProviderId) {
    return RequesterV1.get(
      `service_provider/tech_visits/producer_inspectors/${serviceProviderId}/fetch_producers`
    );
  },

  create(serviceProviderId, inspectorId, producer_inspector) {
    return RequesterV1.post(
      `service_provider/tech_visits/producer_inspectors/${serviceProviderId}/create/${inspectorId}`,
      { producer_inspector }
    );
  },

  destroy(serviceProviderId, inspectorId, producerId) {
    return RequesterV1.delete(
      `service_provider/tech_visits/producer_inspectors/${serviceProviderId}/destroy/${inspectorId}/${producerId}`
    );
  }
};
